import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';
import {invalidateAccounts} from 'modules/store/accounts';
import {TIMEOUT_STORE} from 'util/constants';

const
    mapFields = {
        subscription_id: 'subscriptionId',
        customer_id:     'customerId'
    },
    transformEntitiesToSaveFn = account => Object.keys(account.vendor)
        .reduce((ret, key) => ({
            ...ret,
            subscription_id: account.vendor.subscriptionId,
            customer_id:     account.vendor.customerId
        }), {
            name: account.name
        }),
    transformEntitiesFn = account => {
        if (typeof account !== 'object') {
            throw new Error('transformAzure needs an object to transform');
        }

        return {
            id:        account.id,
            name:      account.alias,
            reselling: account.reselling,
            vendor:    {
                selected: vendorCodes.azure_csp,
                values:   {
                    subscriptionId: account.subscription_id,
                    customerId:     account.customer_id
                }
            }
        };
    };

const exports = storeModuleFactory({
    name:             'azureAccounts',
    endpoint:         endpoints.accounts.azure.endpoint,
    instanceEndpoint: endpoints.accounts.azure.instanceEndpoint,
    callbackActions:  [{
        method: 'update',
        action: invalidateAccounts
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/azureAccounts.js